import { Field, MediaConstraints, MediaSchemaType, MediaType, SchemaTypeIds } from "@contentchef/contentchef-types";
import { ListItemIds } from "../../types";
import { SerializedField } from "../types";

export interface MediaMetaConstraints {
  required: boolean;
  type: MediaType;
}

export type SerializedMediaSchema = SerializedField<MediaMetaConstraints, {}>;

export function retrieveEditingType(constraints: MediaConstraints): ListItemIds {
  if (constraints.type === "video") {
    return ListItemIds.VideoWithMetadata;
  }
  if (constraints.type === "image") {
    return ListItemIds.ImageWithMetadata;
  }
  if (constraints.type === "raw") {
    return ListItemIds.RawWithMetadata;
  }

  throw new Error("Invalid media type");
}

export function deserialize(serialized: SerializedMediaSchema): Field<MediaSchemaType> {
  return {
    constraints: {
      required: serialized.constraints.required!,
      type: serialized.constraints.type!,
    },
    labels: serialized.labels,
    placeholder: Object.keys(serialized.placeholder).length > 0 ? serialized.placeholder : undefined,
    hint: Object.keys(serialized.hint).length > 0 ? serialized.hint : undefined,
    name: serialized.name,
    type: SchemaTypeIds.MEDIA,
    extension: serialized.extension,
    translatable: serialized.translatable,
    compact: serialized.compact,
  };
}

// tslint:disable-next-line:max-line-length
export function serialize(deserialized: Field<MediaSchemaType>, initialIndex: number): SerializedMediaSchema {
  return {
    settings: {},
    constraints: {
      required: deserialized.constraints.required,
      type: deserialized.constraints.type,
    },
    labels: deserialized.labels,
    hint: deserialized.hint || {},
    placeholder: deserialized.placeholder || {},
    name: deserialized.name,
    type: deserialized.type,
    editingType: retrieveEditingType(deserialized.constraints),
    initialIndex,
    extension: deserialized.extension,
    translatable: deserialized.translatable,
    compact: deserialized.compact,
  };
}
